module.exports = __webpack_public_path__ + "img/pew_33.088920c2.png";